export default "__VITE_ASSET__B8koY9uv__"